import axios, { AxiosResponse } from "axios";
import { IConfiguration } from "../Types/IConfiguration";

const api = axios.create({
  baseURL: "https://api.farooqiah.co.uk/",
  timeout: 10000,
  headers: { token: "b486d351-7cef-4da8-90c6-09fc3dca546f" },
});

export const ConfigurationService = (): Promise<IConfiguration | void> => {
  return api
    .get("Configuration", {
      params: {
        token: "b486d351-7cef-4da8-90c6-09fc3dca546f",
      },
    })
    .then((response: AxiosResponse<IConfiguration>) => {
      console.log("configuration api called @ " + new Date());
      console.log(response.data);

      var configuration: IConfiguration = {
        Id: response.data.Id,
        Slide2: response.data.Slide2,
        Slide3: response.data.Slide3,
        ShowDuas: response.data.ShowDuas,
      };

      return configuration;
    })
    .catch(function (error: any) {
      console.log("configuration api error @ " + new Date());
      console.log(error);
      return;
    });
};
